/* ============================================================
   PON PON CART — Custom Cart JS
   Handles: pack upgrade prompt, discount toggle, checkout btn total
   ============================================================ */

(function() {
  'use strict';

  var INVENTORY_ENDPOINT = '/apps/ponpon-stock?checkout_catalog=1';
  var BUNDLE_PRODUCT_ID = 8443599683684;
  var checkoutGuardBypass = false;

  // ── Shared cart data cache ────────────────────────────────
  var cartDataCache = null;
  function getCart() {
    if (cartDataCache) {
      return Promise.resolve(cartDataCache);
    }
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartDataCache = cart;
        return cart;
      });
  }

  function invalidateCartCache() {
    cartDataCache = null;
  }

  function getBundleRemovalButton(event) {
    var path = event && typeof event.composedPath === 'function'
      ? event.composedPath()
      : [];

    for (var index = 0; index < path.length; index += 1) {
      var element = path[index];
      if (element && typeof element.matches === 'function' &&
          element.matches('[data-ponpon-remove-bundle]')) {
        return element;
      }
    }

    var target = event && event.target;
    return target && typeof target.closest === 'function'
      ? target.closest('[data-ponpon-remove-bundle]')
      : null;
  }

  function setBundleRemovalError(button, message) {
    var container = button && button.parentElement;
    var error = container && container.querySelector('[data-ponpon-bundle-remove-error]');
    if (!error) return;
    error.textContent = message;
    error.classList.remove('hidden');
  }

  function removeComponentBundle(button) {
    if (!button || button.disabled) return;

    var bundleId = button.dataset.ponponBundleId;
    var bundleSystem = button.dataset.ponponBundleSystem;
    var lineItemKey = button.dataset.ponponLineItemKey;
    if (!bundleId || !lineItemKey) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setBundleRemovalError(button, '');
    var error = button.parentElement && button.parentElement.querySelector('[data-ponpon-bundle-remove-error]');
    if (error) error.classList.add('hidden');
    document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

    fetchFreshCart()
      .then(function(cart) {
        var updates = {};
        if (bundleSystem === 'components-v2') {
          var parentExists = (cart.items || []).some(function(item) {
            return item.key === lineItemKey &&
              item.properties &&
              item.properties._ponpon_bundle_system === 'components-v2' &&
              item.properties._ponpon_bundle_schema === 'v2';
          });
          if (parentExists) updates[lineItemKey] = 0;
        } else {
          (cart.items || []).forEach(function(item) {
            var properties = item.properties || {};
            if (properties._ponpon_bundle_system === 'components-v1' &&
                properties._ponpon_bundle_id === bundleId) {
              updates[item.key] = 0;
            }
          });
        }

        if (!Object.keys(updates).length) {
          var missingError = new Error('bundle missing');
          missingError.name = 'PonPonBundleMissingError';
          throw missingError;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates,
            sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
            sections_url: window.location.pathname
          })
        });
      })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || data.status) {
            throw new Error('bundle removal failed');
          }
          return data;
        });
      })
      .then(function(data) {
        invalidateCartCache();
        document.body.dispatchEvent(
          new CustomEvent('shapes:cart:cartqtychange', {
            bubbles: true,
            detail: {
              response: data,
              key: lineItemKey,
              quantity: 0,
              previousQuantity: null,
              variantId: null,
              originalTarget: button
            }
          })
        );
      })
      .catch(function(error) {
        setBundleRemovalError(
          button,
          error.name === 'PonPonBundleMissingError'
            ? button.dataset.ponponBundleMissingError
            : button.dataset.ponponBundleRemoveMessage
        );
      })
      .finally(function() {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
      });
  }

  function fetchFreshCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function(response) {
      if (!response.ok) throw new Error('could not refresh cart');
      return response.json();
    });
  }

  function fetchInventoryResponseWithRetry() {
    var retryDelays = [0, 400, 1200];
    var attempt = 0;
    var lastError = new Error('inventory service unavailable');

    function runAttempt() {
      var delay = retryDelays[attempt];
      return new Promise(function(resolve) {
        setTimeout(resolve, delay);
      }).then(function() {
        var separator = INVENTORY_ENDPOINT.indexOf('?') === -1 ? '?' : '&';
        return fetch(INVENTORY_ENDPOINT + separator + 'retry=' + Date.now() + '-' + attempt, {
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        });
      }).then(function(response) {
        if (response.ok) return response;

        lastError = new Error('inventory service returned ' + response.status);
        lastError.ponponRetryable = response.status >= 500 || response.status === 429;
        throw lastError;
      }).catch(function(error) {
        lastError = error;
        if (error.ponponRetryable === false) throw lastError;
        attempt += 1;
        if (attempt >= retryDelays.length) throw lastError;
        return runAttempt();
      });
    }

    return runAttempt();
  }

  function fetchBundleInventory() {
    return fetchInventoryResponseWithRetry().then(function(response) {
      return response.json();
    }).then(function(inventory) {
      var config = inventory.config || (window.PonPonComponentBundle && window.PonPonComponentBundle.config);
      if (config && config.state !== 'active') {
        throw new Error(config.updatingMessage || 'Bundle builder is currently updating. Please try again in a moment.');
      }
      if (config && window.PonPonComponentBundle) window.PonPonComponentBundle.setConfig(config);
      var quantities = inventory.inventory || inventory;
      var flavors = config && config.flavors || [
        { key: 'strawberry' }, { key: 'matcha' }
      ];
      flavors.forEach(function(flavor) {
        if (!Number.isFinite(quantities[flavor.key]) || quantities[flavor.key] < 0) {
          throw new Error('inventory service returned invalid stock data');
        }
      });
      return quantities;
    });
  }

  function inspectBundleCart(cart) {
    if (window.PonPonComponentBundle) {
      return window.PonPonComponentBundle.inspectCart(cart);
    }

    var requirements = (cart.items || []).reduce(function(required, item) {
      if (Number(item.product_id) !== BUNDLE_PRODUCT_ID) return required;

      var properties = item.properties || {};
      var strawberry = parseInt(properties['Strawberry Milk'], 10) || 0;
      var matcha = parseInt(properties['Matcha Latte'], 10) || 0;
      required.strawberry += strawberry * item.quantity;
      required.matcha += matcha * item.quantity;
      return required;
    }, { strawberry: 0, matcha: 0 });

    return { requirements: requirements, groups: {}, errors: [], priceErrors: [] };
  }

  function setCheckoutError(message, submitter) {
    var footer = submitter && submitter.closest && submitter.closest('[data-cart-footer]');
    var errorEl = footer && footer.querySelector('[data-cart-errors]');
    if (!errorEl) errorEl = document.getElementById('cart-errors');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.style.display = 'block';
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function verifyBundleInventoryBeforeCheckout(submitter) {
    return fetchFreshCart().then(function(cart) {
      var hasBundleLines = (cart.items || []).some(function(item) {
        return Number(item.product_id) === BUNDLE_PRODUCT_ID ||
          item.properties && item.properties._ponpon_bundle_system;
      });
      if (!hasBundleLines) return true;

      // Load the active configuration before inspecting component IDs. This is
      // what lets a newly published third or fourth flavor work on the cart
      // page without shipping another theme build.
      return fetchBundleInventory().then(function(inventory) {
        var inspection = inspectBundleCart(cart);
        var required = inspection.requirements;
        if (inspection.errors.length) {
          throw new Error('one or more component bundles are incomplete. please remove the affected bundle and build it again.');
        }
        // Shopify's market-specific discount Functions own price calculation.
        // Client checks cover bundle completeness and inventory, not comparisons
        // between a USD tier and the shopper's presentment-currency cart total.
        if (Object.keys(required).some(function(key) { return required[key] > Number(inventory[key] || 0); })) {
          throw new Error('one or more bundle flavors no longer have enough inventory. please update your cart and try again.');
        }
        return true;
      });
    }).catch(function(error) {
      var safeMessages = [
        'one or more bundle flavors no longer have enough inventory. please update your cart and try again.',
        'one or more component bundles are incomplete. please remove the affected bundle and build it again.',
        'Bundle builder is currently updating. Please try again in a moment.'
      ];
      setCheckoutError(safeMessages.indexOf(error.message) !== -1
        ? error.message
        : 'we could not verify bundle inventory. please retry checkout in a moment.', submitter);
      return false;
    });
  }

  function guardedCheckout(continueCheckout, submitter) {
    if (submitter) {
      submitter.disabled = true;
      submitter.dataset.originalValue = submitter.value;
    }

    return verifyBundleInventoryBeforeCheckout(submitter).then(function(verified) {
      if (verified) continueCheckout();
      return verified;
    }).finally(function() {
      if (submitter) {
        submitter.disabled = false;
        submitter.value = submitter.dataset.originalValue || submitter.value;
      }
    });
  }

  // ── Pack Upgrade Prompt ───────────────────────────────────
  function loadUpgradePrompt() {
    getCart()
      .then(function(cart) {
        var THRESHOLD = 5499; // $54.99 in cents
        var prompt = document.getElementById('pp-upgrade-prompt');

        if (window.Shopify && Shopify.country && Shopify.country !== 'US') {
          if (prompt) prompt.style.display = 'none';
          return;
        }

        if (!prompt) {
          // Create the element and insert it into the cart drawer
          prompt = document.createElement('div');
          prompt.id = 'pp-upgrade-prompt';
          prompt.className = 'pp-upgrade-prompt px-section';
          // Try to insert before the preorder callout, or after the cart items list
          var callout = document.querySelector('.pp-preorder-callout');
          if (callout && callout.parentNode) {
            callout.parentNode.insertBefore(prompt, callout);
          } else {
            var itemsList = document.querySelector('[data-cart-items] ul');
            if (itemsList && itemsList.parentNode) {
              itemsList.parentNode.insertBefore(prompt, itemsList.nextSibling);
            }
          }
        }

        if (cart.total_price >= THRESHOLD) {
          prompt.style.display = 'none';
          return;
        }

        var gap = THRESHOLD - cart.total_price;
        var dollars = Math.floor(gap / 100);
        var cents = gap % 100;
        var gapFormatted = '$' + dollars + (cents > 0 ? '.' + String(cents).padStart(2, '0') : '');
        prompt.innerHTML =
          '<span class="pp-upgrade-prompt__icon">\uD83D\uDE9A</span>' +
          '<span>add <strong>' + gapFormatted + '</strong> more \u2192 unlock free shipping</span>';
        prompt.style.display = 'flex';
      })
      .catch(function() {
        var el = document.getElementById('pp-upgrade-prompt');
        if (el) el.style.display = 'none';
      });
  }

  // ── Discount Code Toggle ──────────────────────────────────
  function initDiscountToggle() {
    var toggle = document.getElementById('pp-discount-toggle');
    var form = document.getElementById('pp-discount-form');
    if (!toggle || !form) return;

    toggle.addEventListener('click', function() {
      form.classList.toggle('pp-open');
      toggle.textContent = form.classList.contains('pp-open')
        ? 'Hide discount code'
        : 'Have a discount code?';
    });

    var applyBtn = document.getElementById('pp-discount-apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var input = document.getElementById('pp-discount-input');
        if (!input || !input.value.trim()) return;
        guardedCheckout(function() {
          window.location.href = '/checkout?discount=' + encodeURIComponent(input.value.trim());
        }, applyBtn);
      });
    }
  }

  // Recheck every bundle line immediately before checkout.
  document.addEventListener('submit', function(event) {
    var form = event.target;
    var submitter = event.submitter;
    if (checkoutGuardBypass || !form || form.id !== 'cart' ||
        !submitter || submitter.name !== 'checkout') return;

    event.preventDefault();
    guardedCheckout(function() {
      checkoutGuardBypass = true;
      submitter.disabled = false;
      // Native form.submit() does not include the clicked submitter, so add
      // Shopify's checkout field explicitly before bypassing this guard.
      // This avoids requestSubmit re-entering the captured submit handler.
      var checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      form.appendChild(checkoutInput);
      form.submit();
    }, submitter);
  }, true);

  document.addEventListener('click', function(event) {
    var button = getBundleRemovalButton(event);
    if (!button) return;
    event.preventDefault();
    removeComponentBundle(button);
  }, true);

  // ── Checkout Button Total ─────────────────────────────────
  function updateCheckoutBtnTotal() {
    var btn = document.getElementById('pp-checkout-btn');
    if (!btn) return;

    getCart()
      .then(function(cart) {
        var currency = cart.currency || window.Shopify && Shopify.currency && Shopify.currency.active || 'USD';
        var total = (cart.total_price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: currency
        });
        btn.textContent = 'Checkout \u00B7 ' + total;
      });
  }

  // ── Init ──────────────────────────────────────────────────
  function init() {
    initDiscountToggle();
    updateCheckoutBtnTotal();
  }

  // Run on cart drawer open and on cart update
  document.addEventListener('theme:update:cart', function() {
    invalidateCartCache();
    setTimeout(function() {
      updateCheckoutBtnTotal();
    }, 300);
  });

  // MutationObserver to detect when cart drawer becomes visible
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        var el = mutation.target;
        if (el.style.display !== 'none' && el.closest('[data-cart-drawer]')) {
          init();
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Also run on initial load
    setTimeout(init, 500);

    // Watch for cart drawer appearing
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      observer.observe(drawer, { attributes: true, subtree: true });
    }
  });

  // Re-init when Alpine opens the cart
  document.addEventListener('theme:cart:open', init);

})();
